import Vue from 'vue';

import {
  BootstrapVue,
  BIcon,
  BIconSuitHeartFill,
  BIconArrowRepeat,
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.component('BIcon', BIcon);
Vue.component('BIconSuitHeartFill', BIconSuitHeartFill);
Vue.component('BIconArrowRepeat', BIconArrowRepeat);
